import React from "react";
import Logo from '../assets/cbu/cbutranswisata.png'
import { HashLink as Link } from "react-router-hash-link";
import "../css/Footer.css"
import { motion } from "framer-motion"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faTiktok } from '@fortawesome/free-brands-svg-icons'
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'

function Footer () {
    const instagram = () => {
        const instagramProfileUrl = `https://www.instagram.com/sewahiacecbu/profilecard/?igsh=a3drZWo4cHNzNWpv`;
        window.open(instagramProfileUrl, '_blank', 'noopener noreferrer');
      };
      const facebook = () => {
        const instagramProfileUrl = `https://www.facebook.com/share/1BL1Hvggai/?mibextid=wwXIfr`;
        window.open(instagramProfileUrl, '_blank', 'noopener noreferrer');
      };
      const tiktok = () => {
        const instagramProfileUrl = `https://www.tiktok.com/@sewa.hiace.cbu?_t=ZS-8t3CuafuEIa&_r=1`;
        window.open(instagramProfileUrl, '_blank', 'noopener noreferrer');
      };

      const whatsapp = () => {
        const whatsappUrl = `https://wa.me/+6281770710004`;
        window.open(whatsappUrl, '_blank', 'noopener noreferrer');
      };


    var year = new Date().getFullYear()
    return (
    <footer class="main-footer" id="footer">
            <div class="container footer-content" >
                <div class="text-white" >
                    <div class="row">
                        <div class="col-md-4">
                        <div class="logo-widget footer-widget">
                        <figure class="logo-box"><motion.img src={Logo} alt="" 
                        
                        initial={{ opacity: 0 }} // Starting state
                        whileInView={{ opacity: 1, transition: {delay:0.3, duration:0.6}}} // When the element comes 
                        into view
                        transition={{ duration: 0.3 }}
                        useMotionValueEvent={{y:'100px'}} /></figure>
                            <motion.div class="text footer-about"
                            
                            initial={{ opacity: 0 }} // Starting state
                            whileInView={{ opacity: 1, transition: {delay:0.4, duration:0.6}}} // When the element comes 
                            into view
                            transition={{ duration: 0.3 }}
                            useMotionValueEvent={{y:'100px'}}>
                                <p class="text-white">Head Office: Jl. Pondok Jati Raya No.18 RT03/03, Jurang Mangu Barat, Kecamatan Pondok Aren, Kota Tangerang Selatan, Banten 15423, Indonesia</p>
                            </motion.div>
                              <motion.ul class="footer-social" 
                                                         
                                                         initial={{ opacity: 0 }} // Starting state
                                                         whileInView={{ opacity: 1, transition: {delay:0.5, duration:0.6}}} // When the element comes 
                                                         into view
                                                         transition={{ duration: 0.3 }}
                                                         useMotionValueEvent={{y:'100px'}}>
                                                            <li> <p> <FontAwesomeIcon icon={faFacebook} onClick={facebook} /></p></li>
                                                            <li> <p> <FontAwesomeIcon icon={faTiktok} onClick={tiktok}/></p></li>
                                                            <li> <p> <FontAwesomeIcon icon={faInstagram} onClick={instagram}/></p></li>
                                                      
                            </motion.ul>
                            </div>
                
                    </div>
                    <div class="col-md-4 footer-title">

                            <ul class="list text-white">
                                    <li>< Link to="#home" class="fw-bold text-white">Home</Link></li>
                                    <li>< Link to="#harga" class="fw-bold text-white">Harga Sewa Hiace</Link></li>
                                    <li>< Link to="#kami" class="fw-bold text-white">Tentang Kami</Link></li>
                                    <li>< Link to="#lokasi" class="fw-bold text-white">Lokasi</Link></li>
                                    <li>< Link to="#footer" class="fw-bold text-white" onClick={whatsapp}>Reservasi Sekarang</Link></li>
                                    
                            </ul>        
                        </div>
                    <motion.div class="col-md-4 footer-booking"
                     
                     initial={{ opacity: 0 }} // Starting state
                     whileInView={{ opacity: 1, transition: {delay:0.7, duration:0.6}}} // When the element comes 
                     into view
                     transition={{ duration: 0.3 }}
                     useMotionValueEvent={{y:'100px'}}>
                    
                        <p class="titlebooking">Contact Center (Setiap Hari)  </p>
                        <div class="contact-widget footer-widget">
    
                        <FontAwesomeIcon class="whatsapp" icon={faWhatsapp} onClick={whatsapp} /> &nbsp; +62 817 707 10004 
                            
                        </div>

                    </motion.div>
                </div>
            </div>
        </div>

        <div class="footer_cbu">
                <div class="footer_copyright row text-white mt-2 mb-2">
                    <div class="col-md-6 copyone">
                        <p>Copyright {year} Cakra Buana Unggul </p>
                    </div>
                    <div class="col-md-6 text-md-end copyone">
                        <p class="text-white">Terms of Use | Privacy Policy</p> 
                       
                    </div>
                </div>
        </div>
       
    
    </footer>



);
}

export default Footer;